import * as yup from 'yup';
import docs from './attachments';
import {
  acessoContraCheque,
  consentimentoDadosSensiveis,
  aceiteInss,
} from './utils/rulesByKey';

export const PPMHerdeiroSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...acessoContraCheque,
    ...dadosSensiveis,
    // ...molestiaGrave,
    ...aceiteInss,
    ...docs.PPMHerdeiroDocs.rules,
    ...docs.molestiaGraveDocs.rules,
  });
};

export const PPMHerdeiroInitialValues = {
  acessoContraCheque: '',
  consentimentoDadosSensiveis: false,
  molestiaGrave: '',
  ...docs.PPMHerdeiroDocs.initialValues,
  ...docs.molestiaGraveDocs.initialValues,
};

export const PPMHerdeiroDocs = {
  ...docs.PPMHerdeiroDocs.docs,
  ...docs.molestiaGraveDocs.docs,
};
